import SystemMeter from '@components/_shared/SystemMeter';
import WeatherWidget from '@components/Sun/WeatherWidget';
import DeviceListPage from '@src/components/_shared/devices/DeviceListPage';
import UnitList from '@src/components/_shared/UnitListContainer/UnitList';
import useMakePageScrollable from '@src/hooks/useMakePageScrollable';
import { Device } from '@src/types/Device';
import { DeviceType } from '@src/types/devices/DeviceConfig.types';
import { SiteMeta } from '@src/types/SiteMeta';
import storeConnector from '@store/storeConnector';
import { ReactElement } from 'react';

interface METProps {
  currentUnit: Device;
  siteMeta: SiteMeta;
}

function MET({ currentUnit, siteMeta }: METProps): ReactElement {
  useMakePageScrollable();
  return (
    <div className='home-row'>
      <div className='fcol'>
        <SystemMeter />
        <UnitList />
      </div>
      <div className='fcol'>
        <DeviceListPage
          currentUnit={currentUnit}
          deviceType={DeviceType.MET}
          isUnitScope={false}
        />
        <WeatherWidget hideForecast={!siteMeta.ui.WeatherForecast_enable} />
      </div>
    </div>
  );
}

export default storeConnector(MET, {
  config: ['siteMeta'],
  service: ['currentUnit'],
});
